import { environment } from './environment/environment';

export const userVariables = {
  baseUrl: `${environment.api}/users`,
  userListUrl: `${environment.api}/users`,
  rolesUrl: `${environment.api}/roles/all`,
  createUrl: `${environment.api}/users/create`,
  profileUrl: `${environment.api}/users/me`,
  impersonateUrl: `${environment.api}/users/me`,
  tenantsUrl: `${environment.api}/tenants`,
  userTenantUrl: `${environment.api}/userTenant`,
};
